module.exports = __webpack_public_path__ + "static/media/logo_igear.aee81fbf.png";